/*
 Note:
 This component is included directly into the sources of this project to simplify the
 build process.

 License:
 Copyright 2019, Indoqa Software Design und Beratung GmbH

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:
 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
 THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
import * as React from 'react'
import {Dispatch, SetStateAction} from 'react'
import {EventHandlers, OnContextEvent} from './treeView.types'

export const treeNodeOnMouseOver = (eventHandlers: EventHandlers) => {
  return (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation()
    eventHandlers.mouseOver.emit({})
  }
}

export const treeNodeOnMouseOut = (
  eventHandlers: EventHandlers,
  containerRef: React.RefObject<HTMLElement>,
  setHover: Dispatch<SetStateAction<boolean>>
) => {
  return (e: React.MouseEvent<HTMLElement>) => {
    // the CSS hover rules must not be used here because they do not work if the context menu veil is rendered
    const els = document.elementsFromPoint(e.clientX, e.clientY)
    if (els.includes(containerRef.current as Element)) {
      return
    }
    e.stopPropagation()
    setHover(false)
    eventHandlers.mouseOut.emit({})
  }
}

export const treeNodeContextMenu = (eventHandlers: EventHandlers) => {
  return (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation()
    const contextEvent: OnContextEvent = {
      timeStamp: e.timeStamp,
      clientX: e.clientX,
      clientY: e.clientY,
      preventDefault: () => e.preventDefault(),
    }
    eventHandlers.context.emit(contextEvent)
  }
}
